import {
	Button, Icon
} from "~/components";
import { Tooltip } from "antd";
import { Fragment } from "react";

function CustomerAction({ item, setItemEdit, openModal, handleStatus, can}) {
	const { status } = item;

	const buttonHandlers = {
		statusConfirm: () => {
			setItemEdit(item);
			handleStatus(item, 'confirm');
		},
		statusPending: () => {
			setItemEdit(item);
			handleStatus(item, 'pending');
		},
		edit: () => {
			setItemEdit(item);
			openModal('addEdit');
		},
		resendPass: () => {
			setItemEdit(item);
			openModal('resendPass');
		},
		delete: () => {
			setItemEdit(item);
			openModal('delete');
		},
		callSupport: () => {
			setItemEdit(item);
			openModal('callSupport');
		},
		transfer: () => {
			setItemEdit(item);
			openModal('transfer');
		},
		editGroup: () => {
			setItemEdit(item);
			openModal('editGroup');
		},
	};

	function renderButtonStatus() {
		if (status.key === "pending") {
			return (
				<Fragment>
					{can.status && (
						<Tooltip title="Duyệt thông tin">
							<Button background green noneBorder leftIcon={Icon.success} onClick={buttonHandlers.statusConfirm} />
						</Tooltip>
					)}
					{can.delete && (
						<Tooltip title="Xóa khách hàng">
							<Button background red noneBorder leftIcon={Icon.delete} onClick={buttonHandlers.delete} />
						</Tooltip>
					)}
				</Fragment>
			);
		} else {
			return (
				<Fragment>
					{can.status && (
						<Tooltip title="Bỏ duyệt thông tin">
							<Button background white noneBorder leftIcon={Icon.arrowLeft} onClick={buttonHandlers.statusPending} />
						</Tooltip>
					)}
					{can.transfer && (
						<Tooltip title="Chuyển nhân viên">
							<Button background white noneBorder leftIcon={Icon.switch} onClick={buttonHandlers.transfer} />
						</Tooltip>
					)}
				</Fragment>
			);
		}
	}

	return (
		<div className="table-action d-flex">
			{renderButtonStatus()}
			{((item.status.key === 'pending' && can.edit) || can.editMaster) && (
				<Tooltip title="Cập nhật thông tin"><Button background blue noneBorder leftIcon={Icon.edit} onClick={buttonHandlers.edit} /></Tooltip>
			)}
			{can.support && (
				<Tooltip title="Gọi điện"><Button background yellow noneBorder leftIcon={Icon.support} onClick={buttonHandlers.callSupport} /></Tooltip>
			)}
			{(can.groups && (can.edit || can.editMaster)) && (
				<Tooltip title="Cập nhật nhóm"><Button background pink noneBorder leftIcon={Icon.users} onClick={buttonHandlers.editGroup} /></Tooltip>
			)}
			{((item.status.key === 'confirm' && can.resendPass)) && (
				<Tooltip title="Reset và gửi lại thông tin đăng nhập id.sikido.vn cho khách hàng"><Button background blue noneBorder leftIcon={Icon.reLoad} onClick={buttonHandlers.resendPass} /></Tooltip>
			)}
		</div>
	);
}

export default CustomerAction;
